import { Title } from '@app/components/core/typography/Title'
import Row from '@app/components/layout/Row'
import { DashboardPageLayout } from '@app/pages/layout/DashboardPageLayout'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'

import { PeopleToMessagePanel } from './sections/messages/PeopleToMessagePanel'
import { useEffect, useState, useCallback } from 'react'

import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { ConversationPanel } from './sections/messages/ConversationPanel'
import { ConversationsPanel } from './sections/messages/ConversationsPanel'
import useMediaQuery from '@app/util/useMediaQuery'

export const ProfileMessages = ({
  conversationId,
}: {
  conversationId?: number
}) => {
  const isMobile = useMediaQuery()
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.messages
  const [_, navigate] = useLocation()
  const [activeConverstaionId, setActiveConversationId] = useState(
    conversationId ?? null,
  )
  const [activeConverstaion, setActiveConversation] = useState<{
    title: string
    unread: boolean
  }>({ title: '', unread: false })

  const closeConversation = () => {
    setActiveConversationId(null)
    setActiveConversation({ title: '', unread: false })
  }

  const handleSetActiveConversation = useCallback(
    (title: string, unread: boolean) => {
      setActiveConversation({ title, unread })
    },
    [],
  )

  useEffect(() => {
    navigate(
      activeConverstaionId
        ? pages.dashboardViewConversation(`${activeConverstaionId}`)
        : pages.dashboardMessages,
    )
  }, [activeConverstaionId, navigate])

  useEffect(() => {
    setActiveConversationId(conversationId ?? null)
  }, [conversationId])

  const showConverstaions = !isMobile || !activeConverstaionId

  return (
    <DashboardPageLayout gap="0">
      <Title.H3>{translations.messages}</Title.H3>
      <Row gap="1.5rem" style={{ alignItems: 'flex-start', flexWrap: 'wrap' }}>
        {showConverstaions && (
          <ConversationsPanel
            conversationId={activeConverstaionId}
            setActiveConverstionId={setActiveConversationId}
            setActiveConversation={handleSetActiveConversation}
          />
        )}
        {activeConverstaionId ? (
          <ConversationPanel
            conversationId={activeConverstaionId}
            conversationTitle={activeConverstaion.title}
            unread={activeConverstaion.unread}
            onClose={closeConversation}
          />
        ) : (
          <PeopleToMessagePanel />
        )}
      </Row>
    </DashboardPageLayout>
  )
}
